import { useParams } from 'react-router-dom';
import ACLRulesTable from '../../../components/acl/ACLRulesTable';

interface ACLConfigProps {
    edgeId?: string;
}

const ACLConfig = ({ edgeId: propEdgeId }: ACLConfigProps) => {
    const { id: paramId } = useParams<{ id: string }>();
    const edgeId = propEdgeId || paramId || '';

    // The ACLRulesTable component is now the "single source of truth" for the ACL UI.
    // It handles:
    // 1. Fetching ACLs
    // 2. Displaying them in a table
    // 3. Opening the ACLModal for creation/editing (if readOnly is false/undefined)
    // 4. Deleting ACLs (if readOnly is false/undefined)

    // We pass readOnly={false} to ensure editing capabilities are enabled here.

    if (!edgeId) {
        return <div>Error: Edge ID not found</div>;
    }

    return (
        <div className="space-y-4">
            <ACLRulesTable edgeGuid={edgeId} readOnly={false} />
        </div>
    );
};

export default ACLConfig;
